module.exports = __webpack_public_path__ + "img/reggiocalabria_hero_card.8594e423.png";